export default {
  state: {
    mainLoader: true // By default loading to hide all the content, will be passed to false after the binding
  },
  mutations: {
    SET_MAIN_LOADER(state, value) {
      console.trace()
      console.log('Inside SET_MAIN_LOADER - value', value)
      state.mainLoader = value
    }
  },
  actions: {},
  getters: {
    GET_MAIN_LOADER: (state) => {
      return state.mainLoader
    }
  },
}
